/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Region_CreatedInputs */

const en_region_created = /** @type {(inputs: Region_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Region created`)
};

const es_region_created = /** @type {(inputs: Region_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Region creada`)
};

/**
* | output |
* | --- |
* | "Region created" |
*
* @param {Region_CreatedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const region_created = /** @type {((inputs?: Region_CreatedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Region_CreatedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_region_created(inputs)
	return es_region_created(inputs)
});